export const PaymentOptionEnum = {
    FullPayment: 'full-payment',
    Monthly: 'monthly'
}